import React, { useContext, useState, useEffect } from "react";
import "../assets/style.css";
import { LogIn, UserRoundCog } from 'lucide-react';
import "../assets/vendor/animate.css/animate.min.css"
import "../assets/vendor/bootstrap/css/bootstrap.min.css";
import "../assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "../assets/vendor/boxicons/css/boxicons.min.css";
import "../assets/vendor/swiper/swiper-bundle.min.css";
import oasisLogo from "../assets/img/oasislogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { Link } from 'react-router-dom';
import { AuthContext } from "../contexts/AuthContext";

export const Header = () => {

    const auth = useContext(AuthContext);
    const [isMobileNavActive, setIsMobileNavActive] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 100);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleMobileNavToggle = () => {
        setIsMobileNavActive(!isMobileNavActive);
    };

    const handleMenuItemClick = (e) => {
        if (isMobileNavActive) {
            setIsMobileNavActive(false);
        }
    };

    const handleDropdownClick = (e) => {
        if (isMobileNavActive) {
            e.preventDefault();
            e.stopPropagation();
            const dropdownList = e.currentTarget.nextElementSibling;
            if (dropdownList) {
                dropdownList.classList.toggle('dropdown-active');
            }
        }
    };

    return (
        <>
            <header id="header" className={`fixed-top ${isScrolled ? 'header-scrolled' : ''}`}>
                <div className="p-2 me-2 ">
                    <div className="text-right">
                        <div className="flex flex-row justify-end items-center gap-2 text-sm flex-nowrap overflow-x-auto">
                            <div className="whitespace-nowrap hidden sm:inline">
                                <strong>Call Us:</strong> +91 9469844596, 0194-2310701
                            </div>
                            <div className="whitespace-nowrap">
                                <strong>Email Us:</strong>
                                <a href="mailto:info@oasissgr.in" className="text-blue-600 hover:text-blue-800 ml-1">
                                    info@oasissgr.in
                                </a>
                            </div>

                            {!auth.isAdmin() ? (
                                <Link
                                    to="/login"
                                    className="flex items-center text-black no-underline hover:text-gray-700 hidden sm:block"
                                >
                                    <LogIn className="inline-block w-4 h-4 sm:w-5 sm:h-5 ml-1 sm:ml-2" />
                                    <span className="ml-1">Login</span>
                                </Link>
                            ) : (
                                <Link
                                    to="/admin"
                                    className="flex items-center text-black no-underline hover:text-gray-700 hidden sm:block"
                                >
                                    <UserRoundCog className="inline-block w-4 h-4 sm:w-5 sm:h-5 ml-1 sm:ml-2" />
                                    <span className="ml-1">Admin Portal</span>
                                </Link>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container flex items-center justify-between">
                    <h1 className="logo">
                        <Link to="/">
                            <img
                                className=" w-auto h-16 max-[400px]:w-24 max-[400px]:h-12 
                                            sm:h-16 
                                            md:h-24 md:w-64 
                                            lg:h-56 lg:w-96 
                                            xl:h-5 xl:w-[100px] 
                                            max-h-[160px] min-h-[48px] 
                                            object-contain object-center 
                                            transition-all duration-300"

                                src={oasisLogo} alt="no png found" />
                        </Link>
                    </h1>

                    <nav className={`navbar ${isMobileNavActive ? 'navbar-mobile' : ''}`}>

                        {isMobileNavActive && (
                            <>
                                <button
                                    className="mobile-nav-close"
                                    onClick={handleMobileNavToggle}
                                    aria-label="Close mobile menu"
                                >
                                    <i className="bi bi-x"></i>
                                </button>

                                <div className="mobile-contact-info px-4 py-2 text-sm text-gray-800 bg-gray-100 rounded-lg mb-4">
                                    <p className="mb-1"><strong>Call Us:</strong> +91 9469844596, 0194-2310701</p>
                                    <p><strong>Email:</strong> info@oasissgr.in</p>

                                    {/* Mobile Social Links */}
                                    <div className="flex gap-3 mt-2 text-gray-600">
                                        <a href="https://www.facebook.com/share/qKUCJp7W477txCNU/" target="_blank" rel="noopener noreferrer">
                                            <i className="bi bi-facebook text-base"></i>
                                        </a>
                                        <a href="https://www.instagram.com/oasis.sgr" target="_blank" rel="noopener noreferrer">
                                            <i className="bi bi-instagram text-base"></i>
                                        </a>
                                        <a href="https://www.linkedin.com/company/oasis-educational-institute/" target="_blank" rel="noopener noreferrer">
                                            <i className="bi bi-linkedin text-base"></i>
                                        </a>
                                        <a href="https://x.com/oeisgr" target="_blank" rel="noopener noreferrer">
                                            <FontAwesomeIcon icon={faXTwitter} className="text-base" />
                                        </a>
                                        <a href="https://www.youtube.com/@oasishighersecondaryeducat9744" target="_blank" rel="noopener noreferrer">
                                            <i className="bi bi-youtube text-base"></i>
                                        </a>
                                    </div>
                                </div>
                            </>
                        )}

                        <ul className="flex flex-col lg:flex-row" onClick={handleMenuItemClick}>
                            <li className="active">
                                <Link to="/">Home</Link>
                            </li>
                            <li >
                                <Link to="/admission">Admission</Link>
                            </li>

                            <li >
                                <Link to="/news">News</Link>
                            </li>

                            <li >
                                <Link className="nav-link" to="/management">Management</Link>
                            </li>

                            <li>
                                <Link to="/gallery">Gallery</Link>
                            </li>
                            <li className="dropdown">
                                <Link className="nav-link d-flex align-items-center" onClick={handleDropdownClick} to="">
                                    Downloads
                                    <i className="bi bi-chevron-down"></i>
                                </Link>
                                <ul>
                                    <li> <Link className="nav-link" to="/assignments">Assignments</Link></li>
                                    <li> <Link className="nav-link" to="/syllabus">Syllabus</Link></li>
                                    <li> <Link className="nav-link" to="/model-papers">Model Papers</Link></li>
                                    <li>
                                        <a className="nav-link" href="public/OasisProspectus.pdf" download>
                                            Oasis Prospectus
                                        </a>
                                    </li>

                                </ul>
                            </li>
                            <li className="dropdown">
                                <Link className="nav-link d-flex align-items-center" onClick={handleDropdownClick} to="">
                                    More
                                    <i className="bi bi-chevron-down"></i>
                                </Link>
                                <ul>
                                    <li> <Link className="nav-link" to="/about">About us</Link></li>
                                    <li><Link className="nav-link" to="/oasis-creche">Oasis Creche</Link></li>
                                    <li><Link className="nav-link" to="/faculty">Faculty</Link></li>
                                    <li>  <Link className="nav-link" to="/careers">Careers</Link></li>
                                </ul>
                            </li>
                        </ul>
                    </nav>

                    <div className="flex items-center gap-4">
                        <button
                            className="mobile-nav-toggle"
                            onClick={handleMobileNavToggle}
                            aria-label="Toggle mobile menu"
                        >
                            <i className={`bi ${isMobileNavActive ? 'bi-x' : 'bi-list'}`}></i>
                        </button>

                        <div className="header-social-links hidden lg:flex gap-2">
                            <a href="https://www.facebook.com/share/qKUCJp7W477txCNU/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="facebook">
                                <i className="bi bi-facebook smicon-large"></i>
                            </a>
                            <a href="https://www.instagram.com/oasis.sgr?igsh=dWI0c210b2VrYTgz" target="_blank" rel="noopener noreferrer" className="instagram hover-pink">
                                <i className="bi bi-instagram smicon-large "></i>
                            </a>
                            <a href="https://www.linkedin.com/company/oasis-educational-institute/" target="_blank" rel="noopener noreferrer" className="linkedin">
                                <i className="bi bi-linkedin smicon-large"></i>
                            </a>
                            <a href="https://x.com/oeisgr" target="_blank" rel="noopener noreferrer" className="twitter hover-lightblack">
                                <FontAwesomeIcon icon={faXTwitter} className="smicon-large" />
                            </a>
                            <a href="https://www.youtube.com/@oasishighersecondaryeducat9744" target="_blank" rel="noopener noreferrer" className="youtube hover-red">
                                <i className="bi bi-youtube smicon-large "></i>
                            </a>

                        </div>
                    </div>
                </div>

                <style jsx>
                    {`
        .navbar-mobile {
          position: fixed;
          overflow: hidden;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          background: rgba(235, 235, 235, 0.9);
          transition: 0.3s;
          z-index: 999;
          padding: 4rem 1rem;
        }
        
        .navbar-mobile ul {
           display: block;
                    position: absolute;
                    top: 120px; /* Increased to accommodate contact info */
                    right: 15px;
                    bottom: 15px;
                    left: 15px;
                    padding: 10px 0;
                    border-radius: 10px;
                    background-color: #fff;
                    overflow-y: auto;
                    transition: 0.3s;
        }
   .mobile-contact-info a {
                    text-decoration: none;
                    color: inherit;
                }

        .navbar-mobile a {
          padding: 10px 20px;
          font-size: 15px;
          color : black;
          display: block;
        }

        .navbar-mobile .dropdown ul {
          position: static;
          display: none;
          margin: 10px 20px;
          padding: 10px 0;
          z-index: 99;
          opacity: 1;
          visibility: visible;
          background: #fff;
          box-shadow: 0px 0px 30px rgba(228, 230, 238, 0.73);
        }

        .navbar-mobile .dropdown-active > ul {
          display: block;
        }

        .mobile-nav-toggle {
          display: none;
          color: #37517e;
          font-size: 28px;
          cursor: pointer;
          line-height: 0;
          transition: 0.5s;
        }

        .mobile-nav-close {
          position: absolute;
          top: 15px;
          right: 15px;
          color: #fff;
          font-size: 28px;
          cursor: pointer;
          z-index: 9999;
          background: none;
          border: none;
          padding: 5px;
        }

        .mobile-nav-close i {
          font-size: 32px;
        }

        @media (max-width: 1024px) {
          .mobile-nav-toggle {
            display: block;
          }
          
          .navbar:not(.navbar-mobile) {
            display: none;
          }
        }

        @media (max-width: 768px) {
          .logo img {
            width: 100px; /* Adjust the width as needed */
          }
        }
      `}</style>
            </header>
        </>
    );
};